export {fetchLayerData} from './maps-v3-client';




// WEBPACK FOOTER //
// ./src/app/common/services/fetch-layer-data/api/index.ts